import { useAuth } from "@/context/AuthContext";
import NotificationBell from "@/components/NotificationBell";
import { Link } from "react-router-dom";
import { AlertCircle, X } from "lucide-react";
import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Topbar() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const showVerify = user && user.role !== "patient" && user.email_verified === false && !dismissed;

  const resend = async () => {
    try { await api.post("/auth/resend-verification"); toast.success("Verification email sent."); }
    catch { toast.error("Could not send verification email."); }
  };

  return (
    <div className="border-b border-[#E8E6E1] bg-[#FDFCFB]" data-testid="app-topbar">
      {showVerify && (
        <div className="px-6 lg:px-10 py-2.5 bg-[#FFF4E5] border-b border-[#FDE6CC] flex items-center justify-between gap-3 text-xs" data-testid="email-verify-banner">
          <div className="flex items-center gap-2 text-[#A65D00]">
            <AlertCircle size={14} />
            <span>Your email isn't verified yet. <button onClick={resend} className="underline font-semibold ml-1" data-testid="resend-verify">Resend link</button></span>
          </div>
          <button onClick={() => setDismissed(true)} className="text-[#A65D00] hover:text-[#5C3500]"><X size={14} /></button>
        </div>
      )}
      <div className="px-6 lg:px-10 py-3 flex items-center justify-end gap-3">
        <NotificationBell />
      </div>
    </div>
  );
}
